export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.18 6c6.2 0 11.98 3.12 15.48 8.32.62.92.38 2.16-.54 2.76-.92.62-2.16.38-2.78-.54-2.76-4.1-7.3-6.54-12.16-6.54-4.72 0-9.4 2.68-12.54 7.14-.4.56-1.02.86-1.64.86-.4 0-.8-.12-1.14-.36a1.978 1.978 0 01-.5-2.78C4.24 9.3 10.16 6 16.18 6zM16 14c-3.68 0-6.84 1.66-9.16 4.82-.64.88-.46 2.14.44 2.8.36.26.76.38 1.18.38a2 2 0 001.62-.82C11.62 19.08 13.62 18 16 18s4.38 1.08 5.92 3.18c.66.88 1.9 1.08 2.8.42.88-.66 1.08-1.9.42-2.8-2.3-3.14-5.46-4.8-9.14-4.8zm0 14a3 3 0 100-6 3 3 0 000 6z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};